import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Grid,
  Modal,
  FileUpload,
  Table,
  Form,
  Select,
  Stepper,
  ODataTable,
  Panel,
  WebRequest,
  Checkbox,
} from 'framework-ui-components';
import TrashIcon from 'framework-ui-components/Components/Icons/TrashIcon';
import { SnackbarWrapper as SnackbarManager } from 'framework-ui-components/Components/Snackbar';
import uuid from 'uuid';
import AssistenteInlineIcon from '../../../components/Icons/AssistenteInlineIcon';
import FileSelector from '../../../components/FileSelector';
import { listaPdfImportabili730 } from '../../../apis/setteTrentaApi';
import apriPermalinkAssistente from '../../../helpers/apriPermalinkAssistente';

const MAX_FILE_SIZE = 100;

const FileSelezionato = ({ item, additionalRowData }) => (
  <tr>
    <td>{item.name}</td>
    <td>{(item.size / (1024 * 1024)).toFixed(2)} MB</td>
    <td>
      <Button icon onClick={() => additionalRowData.onElimina(item)}>
        {' '}
        <TrashIcon />
      </Button>
    </td>
  </tr>
);

FileSelezionato.propTypes = {
  item: PropTypes.object.isRequired,
  additionalRowData: PropTypes.object.isRequired,
};

const FileCaricato = ({ item, additionalRowData }) => (
  <tr>
    <td>{item.name}</td>
    <td>{(item.size / (1024 * 1024)).toFixed(2)} MB</td>
    <td>{item.Progresso == undefined ? '' : `${item.Progresso}` + ' %'}</td>
  </tr>
);

class ModaleImportazionePdf extends Component {
  constructor(props) {
    super(props);

    this.state = {
      step: 0,
      uploading: false,
      fileImportazioneAbilitati: [],
      fileSelezionati: [],
      origine: null,
      importatoreSconosciuto: false,
      guidSessione: uuid.v4(),
    };

    this.annulla = this.annulla.bind(this);
    this.aggiungiLista = this.aggiungiLista.bind(this);
    this.impostaEsito = this.impostaEsito.bind(this);
    this.precedente = this.precedente.bind(this);
    this.prossimo = this.prossimo.bind(this);
    this.selezionaFile = this.selezionaFile.bind(this);
    this.leggiFileSelezionati = this.leggiFileSelezionati.bind(this);
    this.caricaListaPdfImportabili730 = this.caricaListaPdfImportabili730.bind(
      this,
    );
    this.onElimina = this.onElimina.bind(this);
    this.carica = this.carica.bind(this);
  }

  componentDidMount() {
    this.caricaListaPdfImportabili730();
  }

  caricaListaPdfImportabili730 = () => {
    listaPdfImportabili730().then((res) => {
      if (res) {
        this.setState({ fileImportazioneAbilitati: res });
      }
    });
  };

  aggiungiLista(evt, progress, file) {
    let files = this.state.fileSelezionati;

    if (files.find(x => x.name == file.name)) {
      files.find(x => x.name == file.name).Progresso = (progress * 100).toFixed(
        1,
      );
    } else {
      files = files.concat({
        name: file.name,
        Progresso: (progress * 100).toFixed(1),
      });
    }

    this.setState({ fileCaricati: files });
  }

  impostaEsito(file) {
    let files = this.state.fileSelezionati;

    if (files.find(x => x.name == file.name)) {
      files.find(x => x.name == file.name).Progresso = 100;
    } else {
      files = files.concat({ name: file.name, Progresso: 100 });
    }

    this.setState({ fileCaricati: files });
  }

  selezionaFile(e) {
    const { files } = e.target;
    let file = this.state.fileSelezionati;

    let i = 0;
    for (i = 0; i < files.length; i++) {
      if (file.filter(x => x.name == files[i].name).length == 0) {
        // se presente uno con lo stesso nome lo elimino
        file = file.concat(files[i]);
      }
    }

    this.setState({ fileSelezionati: file }, () => this.tabella.loadPage());
  }

  leggiFileSelezionati = (top, skip, sortProperty, sortOrder, filters) => {
    const pagina = this.state.fileSelezionati.slice(skip, skip + top);
    return {
      Items: pagina,
      Count: this.state.fileSelezionati.length,
    };
  };

  annulla() {
    const { onAnnulla } = this.props;
    onAnnulla && onAnnulla();
  }

  carica() {
    if (
      this.state.fileSelezionati.filter(x => x.Progresso == undefined).length
      == 0
    ) {
      this.setState({ uploading: false, step: 3 });
    } else {
      this.caricaSingoloFile(
        this.state.fileSelezionati.filter(x => x.Progresso == undefined)[0],
      );
    }
  }

  caricaSingoloFile(file) {
    const formData = new FormData();
    formData.append('file', file);

    return WebRequest.postFile(
      `/SetteTrenta/ImportaPdf?sessione=${this.state.guidSessione}&studio=${
        this.props.ufficioSelezionato
      }&origine=${!this.state.importatoreSconosciuto ? this.state.origine : 0}`,
      formData,
      null,
      (evt) => {
        const progressPercent = evt.loaded / evt.total;
        this.aggiungiLista(evt, progressPercent, file);
      },
    ).then((res) => {
      this.state.fileSelezionati.filter(
        x => x.name == res.data.Name,
      )[0].Success = res.data.Success;
      if (!res.data.Success) {
        this.state.fileSelezionati.filter(
          x => x.name == res.data.Name,
        )[0].Error = res.data.DetectedProblems[0];
        this.setState({ erroriUpload: true });
      }
      this.carica();
    });
  }

  precedente() {
    if (this.state.step == 3) {
    } else {
      this.setState({ step: this.state.step - 1 });
    }
  }

  prossimo() {
    if (this.state.step == 2) {
      this.setState({ uploading: true });
      this.carica();
    } else if (
      this.state.step !== 1
      || this.state.importatoreSconosciuto
      || this.form.valida()
    ) {
      this.setState({ step: this.state.step + 1 });
    }
  }

  onElimina(item) {
    const { fileSelezionati } = this.state;

    this.setState(
      { fileSelezionati: fileSelezionati.filter(x => x.name != item.name) },
      () => this.tabella.loadPage(),
    );
  }

  render() {
    const { showModal, isLoading, ufficioSelezionato } = this.props;
    const {
      step,
      fileSelezionati,
      uploading,
      fileImportazioneAbilitati,
      origine,
      importatoreSconosciuto,
    } = this.state;

    let disabilitato = false;

    if (step == 0 && fileSelezionati.length == 0) {
      disabilitato = true;
    }
    if (step == 2 && uploading) {
      disabilitato = true;
    }

    return (
      <Modal
        show={showModal}
        onClose={this.annulla}
        loading={isLoading}
        style={{ width: '1000px' }}
        className="modaleImportazionePdf"
      >
        <Modal.Header>
          <span
            className="button--assistente"
            onClick={() => apriPermalinkAssistente('importazione', ufficioSelezionato)}
            role="presentation"
          >
            <AssistenteInlineIcon />
          </span>
          Importa 730 da PDF
        </Modal.Header>
        <Modal.Body>
          <div>
            <Grid fluid>
              <Grid.Row>
                <Grid.Col md="12">
                  <Stepper>
                    <Stepper.Step
                      key={1}
                      title="Seleziona PDF"
                      state={
                        step > 0 ? Stepper.State.DONE : Stepper.State.ACTIVE
                      }
                    >
                      <Grid fluid>
                        <Grid.Row>
                          <Grid.Col md="12">
                            <Panel info>
                              Seleziona i file da allegare, ogni file non può
                              superare la dimensione massima di {MAX_FILE_SIZE}{' '}
                              MB.
                            </Panel>
                            <div className="areaImportazionePdf">
                              <FileSelector
                                onChange={this.selezionaFile}
                                accept={['.pdf']}
                                max={MAX_FILE_SIZE}
                                multiple
                              >
                                <a>Seleziona i files</a> <br />
                              </FileSelector>
                            </div>
                            <ODataTable
                              availablePageSizes={[5, 10]}
                              ref={r => (this.tabella = r)}
                              dataSource={this.leggiFileSelezionati}
                              additionalRowData={{
                                onElimina: this.onElimina,
                              }}
                              pageSize={5}
                              row={FileSelezionato}
                            >
                              <ODataTable.Column>
                                Nome Documento
                              </ODataTable.Column>
                              <ODataTable.Column>Dimensione</ODataTable.Column>
                              <ODataTable.Column>Elimina</ODataTable.Column>
                            </ODataTable>
                          </Grid.Col>
                        </Grid.Row>
                      </Grid>
                    </Stepper.Step>
                    <Stepper.Step
                      key={2}
                      title="Scegli fornitore"
                      state={
                        step > 1
                          ? Stepper.State.DONE
                          : step < 1
                            ? Stepper.State.INACTIVE
                            : Stepper.State.ACTIVE
                      }
                    >
                      <Form
                        stato={this.state}
                        onChange={data => this.setState(data)}
                        ref={r => (this.form = r)}
                      >
                        <Select
                          name="origine"
                          title="Indica la provenienza del file"
                          validations={!importatoreSconosciuto && ['required']}
                          disabled={importatoreSconosciuto}
                        >
                          {fileImportazioneAbilitati
                            .sort((a, b) => (a.Descrizione > b.Descrizione
                              ? 1
                              : a.Descrizione < b.Descrizione
                                ? -1
                                : 0))
                            .map(x => (
                              <Select.Option value={x.Valore}>
                                {x.Descrizione}
                              </Select.Option>
                            ))}
                        </Select>
                        <br />
                        <br />
                        <label>
                          <Checkbox
                            name="importatoreSconosciuto"
                            onChange={() => this.setState({ origine: null })}
                          />
                          Nessuno di quelli proposti
                        </label>
                      </Form>

                      <br />
                    </Stepper.Step>
                    <Stepper.Step
                      key={3}
                      title="Importa PDF"
                      state={
                        step > 2
                          ? Stepper.State.DONE
                          : step < 2
                            ? Stepper.State.INACTIVE
                            : Stepper.State.ACTIVE
                      }
                    >
                      {this.state.uploading && (
                        <Panel alert>
                          Attendi che il caricamento di tutti i file sia
                          completato
                        </Panel>
                      )}

                      <ODataTable
                        availablePageSizes={[5, 10]}
                        ref={r => (this.tabella = r)}
                        dataSource={this.leggiFileSelezionati}
                        additionalRowData={{
                          onElimina: this.onElimina,
                        }}
                        pageSize={5}
                        row={FileCaricato}
                      >
                        <ODataTable.Column>Nome Documento</ODataTable.Column>
                        <ODataTable.Column>Dimensione</ODataTable.Column>
                        <ODataTable.Column>Caricamento</ODataTable.Column>
                      </ODataTable>
                    </Stepper.Step>
                    <Stepper.Step
                      key={4}
                      title="Esito importazione"
                      state={
                        step > 3
                          ? Stepper.State.DONE
                          : step < 3
                            ? Stepper.State.INACTIVE
                            : Stepper.State.ACTIVE
                      }
                    >
                      {this.state.erroriUpload ? (
                        <Panel alert>
                          Alcuni file non sono stati caricati.
                          <ul>
                            {this.state.fileSelezionati
                              .filter(x => x.Success == false)
                              .map(x => (
                                <li>
                                  {x.name}: {x.Error}
                                </li>
                              ))}
                          </ul>
                        </Panel>
                      ) : (
                        <Panel success>
                          Tutti i file sono stati caricati con successo.
                        </Panel>
                      )}
                      <Panel info>
                        {importatoreSconosciuto
                          ? 'Le dichiarazioni saranno disponibili non appena sarà riconosciuto dal sistema il fornitore da cui provengono i file PDF. Riceverai una notifica dal sistema non appena l’importazione sarà stata completata.'
                          : 'Le dichiarazioni saranno disponibili entro 2 giorni lavorativi, previa notifica.'}
                      </Panel>
                    </Stepper.Step>
                  </Stepper>
                </Grid.Col>
              </Grid.Row>
            </Grid>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {step != 3 && step != 0 && (
            <Button flat onClick={this.precedente} disabled={disabilitato}>
              Indietro
            </Button>
          )}
          {step != 3 && (
            <Button
              primary
              flat
              onClick={this.prossimo}
              disabled={disabilitato}
            >
              {step !== 2 ? 'Avanti' : 'Avvia'}
            </Button>
          )}
          {step == 3 && (
            <Button primary flat onClick={this.annulla}>
              Ho capito
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}

ModaleImportazionePdf.propTypes = {
  onAnnulla: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
  ufficioSelezionato: PropTypes.string,
  annoSelezionato: PropTypes.number,
};

export default ModaleImportazionePdf;
